import React, {Component} from 'react';
import './loan-deposit.style.scss';
import downred from 'assets/icons/down-bold-red.svg';
import downredthin from 'assets/icons/down-red.svg';
import upgreenthin from 'assets/icons/up-green.svg';

export default class Loan extends Component {
  render() {
    return (
      <div className='loan-container'>
        <div className='loan-left'>
          <div className='loan-target'>
            <div className='percent'>105%</div>
            <div className='desc'>Target</div>
          </div>
          <div className='loan-updown'>
            <div className='loan-period'>
              <img src={downred} alt='' width={24} height={24} />
              <div>Same Perriod</div>
            </div>
            <div className='loan-price'>
              <div className='price'>986 bil.</div>
              <div className='price-percent'>(3.5%)</div>
            </div>
          </div>
        </div>
        <div className='loan-right'>
          <div className='title'>LOAN</div>
          <div>
            <span className='price'>35,000</span>
            <span className='unit'>bil. VND</span>
          </div>
          <div>
            <span className='desc'>Loan balance</span>

            <span className='text-up'>
              <img src={upgreenthin} alt='' width={16} height={16} />
              3,000 bil. (+7.3%)
            </span>
          </div>
          <div>
            <span className='desc'>Bond balance</span>
            <span className='text-down'>
              <img src={downredthin} alt='' width={16} height={16} />
              1,000 bil. (-2.3%)
            </span>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/LoanAndDeposit/Loan.js